import type { MessageAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'
import type { MessageType } from '@/client/services/conversation'

import ConversationQ from './ConversationQ'
import {
  type AssociationDefinitions,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryOrderToSQL,
} from './common'
import UserQ from './UserQ'

const MessageQ = {
  ...makeQueryModelV2<MessageAttributes>('message')([
    'id',
    'user_id',
    'body',
    'conversation_id',
    'type',
    'hidden_at',
    'created_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    User: {
      query: UserQ,
      foreignKey: UserQ.id,
      sourceKey: MessageQ.user_id,
    },
    Conversation: {
      query: ConversationQ,
      foreignKey: ConversationQ.id,
      sourceKey: MessageQ.conversation_id,
    },
  }),

  where: (
    {
      id,
      type,
      conversationId,
      userId,
      include = [],
      order = null,
      paranoid = true,
    }: {
      id?: number | SQLFragment<number> | null
      type?: MessageType | SQLFragment<MessageType> | null
      conversationId?: number | SQLFragment<number> | null
      userId?: number | SQLFragment<number> | null
      include?: IncludeAssociations
      order?: QueryOrder | null
      paranoid?: boolean
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<MessageAttributes> => SQL`
        FROM ${MessageQ}
        ${includeAssociationsToSql(MessageQ, include)}
        WHERE
            ${id != null ? SQL`${MessageQ.id} = ${id} AND` : SQL``}
            ${type != null ? SQL`${MessageQ.type} = ${type} AND` : SQL``}
            ${
              conversationId != null
                ? SQL`${MessageQ.conversation_id} = ${conversationId} AND`
                : SQL``
            }
            ${userId != null ? SQL`${MessageQ.user_id} = ${userId} AND` : SQL``}
            ${paranoid ? SQL`${MessageQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
            ${queryOrderToSQL(order)}
        `,
}

export default MessageQ
